import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import DatetimePicker from "./plugins/vuetify-datetime-picker";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import PageExplanation from "@/components/shared/PageExplanation.vue";

Vue.config.productionTip = false;
Vue.use(DatetimePicker);
Vue.component("PageExplanation", PageExplanation);

const isAuthCallback =
  typeof window !== "undefined" &&
  window.location.pathname === "/auth/callback" &&
  window.location.search.includes("code=");

// CRITICAL: Do NOT configure Amplify or call any auth functions on /auth/callback
// This prevents Amplify from auto-redeeming the authorization code
if (!isAuthCallback) {
  // Only import and configure Amplify when NOT on callback page
  import("@/auth/client").then(({ configureIfNeeded, sessionCheck }) => {
    configureIfNeeded();

    sessionCheck()
      .then(session => {
        console.log("main.ts: Auth session test:", session);
      })
      .catch(err => {
        console.log(
          "main.ts: Auth session test error (expected if not logged in):",
          err.message
        );
      });
  });
}

console.log("main.ts: Creating and mounting Vue instance...");
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
console.log("main.ts: Vue instance mounted.");
